module.exports = __webpack_public_path__ + "media/src/neighbourhood_map/images/eole-e1ec1abcf69b24a848957f2788d4517f.png";